@if (!viewSecondPanel) {
<div
  class="col se-p second-level-menu scroll-bar usergroup-level right-box-shadow"
>
  <div class="tabs is-centered is-marginless is-small is-mobile display-flex">
    <ul>
      <li class="is-semibold" routerLinkActive="is-active">
        <a [routerLink]="['/userandgroup/user']">User</a>
      </li>
      <li
        class="is-semibold"
        (click)="showCreateClass()"
        routerLinkActive="is-active"
      >
        <a [routerLink]="['/userandgroup/group']">Group</a>
      </li>
    </ul>
  </div>
  @if (showSearchSec) {
  <div class="menu-options level is-marginless display-flex">
    <div class="level-left">
      <div class="level-item">
        <div class="select is-small">
          <select
            [(ngModel)]="sortBy"
            (change)="groupListSortAndSearch(sort, '')"
          >
            <option value="title">Sort A to Z</option>
            <option value="time">Sort by Recent</option>
          </select>
        </div>
      </div>
    </div>
    <div class="level-right">
      <div class="level-item">
        <a
          class="is-small button"
          (click)="showSearchbox('open')"
          title="Search"
        >
          <i class="fa fa-search"></i>
        </a>
        <a
          class="is-small button"
          title="Add new lesson"
          [routerLink]="['/userandgroup/group/newgroup']"
        >
          <i class="fa-solid fa-circle-plus"></i>
        </a>
      </div>
    </div>
  </div>
  } @if (!showSearchSec) {
  <div class="menu-options level is-marginless searchBox-pad display-flex">
    <div class="level-left">
      <div class="level-item input-search-box">
        <div class="field">
          <p class="control has-icons-left has-icons-right">
            <!-- <input class="input" type="text" inputFocus [(ngModel)]="search" (keyup.enter)="groupListSortAndSearch(0)" placeholder="Search"> -->
            <input
              class="input"
              type="text"
              inputFocus
              [(ngModel)]="search"
              (keyup)="searchInList.next($event)"
              placeholder="Search"
            />
            <a class="icon is-small is-left" title="Search">
              <i class="fa fa-search"></i>
            </a>
            <span class="input-bar"></span>
          </p>
        </div>
      </div>
    </div>
    <div class="level-right">
      <div class="level-item">
        <span
          class="icon is-small is-right search-return"
          (click)="showSearchbox('close')"
        >
          <i class="fa fa-times-circle"></i>
        </span>
      </div>
    </div>
  </div>
  }
  <!-- <div class="list-wrapper scroll-bar list-overflow" infinite-scroll [infiniteScrollDistance]="modalScrollDistance" [infiniteScrollThrottle]="modalScrollThrottle"
    [scrollWindow]="false" (scrolled)="onScrollDown()"> -->
  <div
    class="list-wrapper scroll-bar list-overflow scrollUserandGroup"
    appInfiniteScroll
    (reachedBottom)="onScrollDown()"
  >
    <ul>
      @for (group of listOfGroups; track group) {
      <li
        class="cursor-pointer pos-relative chat-list"
        routerLinkActive="active"
      >
        <div
          class="columns is-gapless display-flex"
          [routerLink]="['/userandgroup/group', group.group_id]"
        >
          <div class="column is-one-quarter">
            @if (group.group_icon) {
            <img [src]="profileUrl + group.group_icon" />
            } @if (!group.group_icon) {
            <empty-uname
              [userName]="group.full_name"
              [liProfile]="true"
            ></empty-uname>
            }
          </div>
          <div class="column is-clearfix">
            <p class="is-size-6 list-active">{{ group.full_name }}</p>
            <!-- <div class="is-pulled-left">
                <label>
                  <span class="tag is-light" *ngIf="group.is_private === false">Public</span>
                  <span class="tag is-light" *ngIf="group.is_private === true">Private</span>
                </label>
              </div> -->
            <div class="is-pulled-right">
              <span class="is-size-7 pos-relative">
                {{ group.TotalUserCount ? group.TotalUserCount : 0 }}
                <i class="fa fa-users mar-t-2 mar-l-2" aria-hidden="true"></i>
              </span>
            </div>
          </div>
        </div>
      </li>
      }
      <pagination-loader
        [showFetchLoader]="showPaginateSpinner"
      ></pagination-loader>
    </ul>
  </div>
</div>
} @if (viewSecondPanel) { @if (viewClassRoom==true) {
<div class="col th-p notification-content-wrapper">
  <header class="tob-box-shadow groupMobileView">
    <div class="columns is-gapless is-vcentered display-flex">
      <div class="is-pulled-left">
        <span class=""></span>
      </div>
      <figure class="has-text-centered">
        <i
          class="fa is-pulled-left"
          [ngClass]="{
            'fa-angle-double-left': !this.viewSecondPanel,
            'fa-angle-double-right': this.viewSecondPanel
          }"
          (click)="hideSecondPanel()"
        ></i>
      </figure>
      <div class="is-pulled-left">
        <span class="is-size-6 has-text-weight-semibold">Lesson Creation</span>
      </div>
      <div class="column has-text-right">
        <div class="desk-view">
          <div class="desk-icon">
            <a class="desk-icon">
              <button
                class="button is-small is-link is-outlined"
                [routerLink]="['/userandgroup/group/newgroup']"
              >
                <i class="fa-solid fa-circle-plus"></i> &nbsp;&nbsp;New Lesson
              </button>
            </a>
          </div>
        </div>
      </div>
    </div>
  </header>
</div>
} @if (viewClassRoom===true && totalRowCount === 0) {
<div class="empty-state">
  <div class="has-text-centered box">
    <img [src]="'../../../../assets/images/notification_empty.svg'" />
    <p>No lesson record found. Please check the button below to create user</p>
    <a
      class="button is-link mar-top15"
      [routerLink]="['/userandgroup/group/newgroup']"
    >
      <span class="icon">
        <i class="fa fa-plus"></i>
      </span>
      <span> Create Lesson</span>
    </a>
  </div>
</div>
} }
<router-outlet></router-outlet>
